export default "__VITE_ASSET__3ef036ed__"